<template>
  <card-form
    :collapsed="!isExamCollapsed"
    class="exam__container exam-curve__container exam-item"
  >
    <div
      slot="expanded"
      class="form-container"
    >
      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout md-flex="15">
          <md-input-container
            id="patientIdLis"
            :class="{ 'md-input-invalid': errors.has('idExamCode') }"
          >
            <label>Código do Exame</label>
            <md-input
              id="txtNewExamCode"
              v-model="item.details.code"
              name="idExamCode"
              type="text"
              title=""
              disabled
              placeholder="Código do Exame"
            />
          </md-input-container>
        </md-layout>
        <md-layout md-flex="20">
          <md-input-container
            id="patientName"
            :class="{ 'md-input-invalid': errors.has('examName') }"
          >
            <label>Nome do Exame</label>
            <md-input
              id="txtNewExamName"
              v-model="item.details.name"
              name="examName"
              type="text"
              title=""
              disabled
              placeholder="Nome do Exame"
            />
          </md-input-container>
        </md-layout>
        <md-layout md-flex="20">
          <md-input-container
            id="examMaterial"
            class="md-advanced-select md-input-placeholder md-has-value"
            :class="{
              'md-input-invalid': errors.has('material')
            }"
          >
            <label>Material</label>
            <div class="advanced-select__container">
              <model-list-select
                :id="'cboNewMaterial'"
                v-model="material"
                v-validate="'required'"
                label="label"
                placeholder="Selecione..."
                :options="getAvailableMaterials()"
                name="material"
              >
                <span slot="no-options">
                  <p class="v-select-no-matching">
                    Desculpe, não foram encontrados materiais para essa pesquisa.
                  </p>
                </span>
              </model-list-select>
            </div>
            <span class="md-error">Obrigatório</span>
          </md-input-container>
        </md-layout>
        <md-layout md-flex="10">
          <md-input-container :class="{ 'md-input-invalid': errors.has('samples') }">
            <label class="dont-wrap">Qtd. Amostras</label>
            <md-input
              id="txtNewSampleQuantity"
              maxlength="3"
              type="text"
              :value="totalSelectedTimes"
              title=""
              placeholder="Amostras"
              disabled
            />
            <input
              v-validate="'min_value:2'"
              type="hidden"
              :value="totalSelectedTimes"
              data-vv-validate-on="none"
              name="samples"
            >
            <span class="md-error">Obrigatório conter mais de um tempo</span>
          </md-input-container>
        </md-layout>
        <md-layout md-flex="15">
          <md-input-container
            id="conditioning"
            :class="{ 'md-input-invalid': errors.has('conditioning') }"
          >
            <label>Acondicionamento</label>
            <md-input
              id="txtNewConditioning"
              v-model="conditioning"
              name="conditioning"
              type="text"
              title=""
              disabled
              value="Acondicionamento"
              placeholder="Acondicionamento"
            />
          </md-input-container>
        </md-layout>
      </md-layout>

      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout
          v-if="item.details.deadline?.trim()"
          md-flex="15"
        >
          <md-input-container id="deadline">
            <label>Prazo de execução</label>
            <md-input
              id="txtDeadline"
              v-model="item.details.deadline"
              name="deadline"
              type="text"
              title=""
              disabled
              placeholder="Prazo de execução"
            />
          </md-input-container>
        </md-layout>
        <md-layout
          v-if="item.details.minimumVolume?.trim()"
          md-flex="15"
        >
          <md-input-container id="minimumVolume">
            <label>Volume Mínimo</label>
            <md-input
              id="txtMinimumVolume"
              v-model="item.details.minimumVolume"
              name="minimumVolume"
              type="text"
              title=""
              disabled
              placeholder="Volume Mínimo"
            />
          </md-input-container>
        </md-layout>
      </md-layout>

      <md-layout class="exam-curve__curves">
        <h2 class="form-title">
          Períodos de Curvas
        </h2>
        <div class="exam-curve__curves__items">
          <div
            v-for="item in collectTimesOrdered"
            :key="item.id"
            class="exam-curve__curves__item"
          >
            <md-tooltip
              v-if="isEditingOrder && item.processing_origin === 'U'"
              md-direction="top"
            >
              <ul>
                <li>A edição de tempos está bloqueada</li>
                <li>pois esse exame é proveniente de</li>
                <li>importação. Para alterá-los, exclua</li>
                <li>a OS e importe-a novamente.</li>
              </ul>
            </md-tooltip>
            <div class="styled-checkbox">
              <input
                :id="'chbxID' + item.id + '-' + id"
                v-model="listCurveItems"
                type="checkbox"
                :disabled="(isEditingOrder && item.processing_origin === 'U') || item.time === 'Basal'"
                :value="item.id"
              >
              <label :for="'chbxID' + item.id + '-' + id" />
            </div>
            <label
              :for="'chbxID' + item.id + '-' + id"
              :title="item.time"
              class="exam-curve__curves__item__label"
            >
              {{ item.time }}
            </label>
          </div>
        </div>
      </md-layout>

      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout md-flex="50">
          <md-input-container id="examComments">
            <label>Observação</label>
            <div
              class="orders-new__observation-container"
              @keydown.enter.capture="preventRawEnterFromPropagation"
            >
              <md-textarea
                id="txtNewAddExamNote"
                v-model="notes"
                v-validate=""
                maxlength="250"
                type="text"
                name="exam.comments"
                title=""
                placeholder="Observação"
                @keydown.enter.native="focusNextField('btnNewSubmitExam')"
              />
            </div>
          </md-input-container>
        </md-layout>
        <md-layout
          md-flex="15"
          class="exam-item__details"
        >
          <div class="exam-item__details-anchor">
            <md-icon
              md-src="/static/images/icon-info.svg"
              class="exam-item__details-icon"
            />
            <a
              id="txtNewExamDetails"
              tabindex="-1"
              :href="'/exames/detalhes?mnemonic=' + item.details.code"
              target="_blank"
              class="exam-item__details-anchor__text"
            >
              Detalhes do Exame
            </a>
          </div>
        </md-layout>
        <md-layout
          md-flex="15"
          class="exam-item__details priority"
        >
          <div v-if="item.details.allowUrgent && allowExamUrgent">
            <md-switch
              v-if="item.details.nobleMaterial === false"
              id="priorityUrgent"
              v-model="urgent"
              name="urgent"
              class="md-primary"
            >
              Urgente
            </md-switch>
          </div>
          <p v-if="item.details.nobleMaterial && !item.details.allowUrgent">
            Este é um material nobre
          </p>
        </md-layout>
        <md-layout md-flex="20">
          <md-button
            id="btnNewSubmitExam"
            class="btn btn-primary orders-new__patient__submit-button submit-button"
            :data-index="index"
            @click="validateBeforeSubmit"
            @keydown.enter.native="validateBeforeSubmit"
          >
            OK
          </md-button>
        </md-layout>
      </md-layout>

      <md-button
        v-if="!disableDeletion"
        class="md-icon-button card-form__delete-button"
        @click="deleteOrderExams(item)"
      >
        <md-icon class="card-form__delete-button-icon icon-delete-alt" />
        <md-tooltip
          md-delay="400"
          md-direction="top"
        >
          Excluir exame
        </md-tooltip>
      </md-button>
    </div>

    <md-layout
      slot="collapsed"
      class="collapsed-container card-form--collapsed"
      :md-gutter="24"
      md-flex="100"
      @click.native="editExam(item)"
    >
      <md-layout
        class="collapsed__item"
        md-flex="15"
      >
        <div class="md-input-container md-theme-default">
          <h3>Código do Exame</h3>
          <p :title="item.details.code">
            {{ item.details.code }}
          </p>
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="35"
      >
        <div class="md-input-container md-theme-default">
          <h3>Nome do Exame</h3>
          <p :title="item.details.name">
            {{ item.details.name }}
          </p>
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="20"
      >
        <div class="md-input-container md-theme-default">
          <h3>Material</h3>
          <p
            class="material"
            :title="materialName"
          >
            {{ materialId }} - {{ materialName }}
          </p>
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="10"
      >
        <div class="md-input-container md-theme-default">
          <h3 class="dont-wrap">
            Qtd. Amostras
          </h3>
          <p>{{ totalSelectedTimes }}</p>
        </div>
      </md-layout>
      <md-layout
        class="collapsed__item"
        md-flex="15"
      >
        <div class="md-input-container md-theme-default">
          <h3>Acondicionamento</h3>
          <p
            class="md20"
            :title="conditioning"
          >
            {{ conditioning }}
          </p>
        </div>
      </md-layout>
      <p
        id="btnNewEditExam"
        class="collapsed__list__item__edit-button"
        :class="{ 'collapsed__list__item__delete-button': disableDeletion }"
        @click="editExam(item)"
      >
        <md-icon class="collapsed__list__item__edit-button__icon icon-edit-alt" />
        <md-tooltip
          md-delay="400"
          md-direction="top"
        >
          Editar exame
        </md-tooltip>
      </p>
      <p
        v-if="!disableDeletion"
        id="btnNewDeleteExam"
        class="collapsed__list__item__delete-button"
        @click.prevent="deleteOrderExams(item)"
      >
        <md-icon class="card-form__delete-button-icon icon-delete-alt" />
        <md-tooltip
          md-delay="400"
          md-direction="top"
        >
          Excluir exame
        </md-tooltip>
      </p>
    </md-layout>
  </card-form>
</template>

<script>
import mixin from './examMixin'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CurveExam',
  mixins: [mixin],
  data: () => {
    return {
      listCurveItems: [],
      id: -1
    }
  },
  methods: {
    beforeSucessAddNewExam() {
      this.updateExam({
        raw: this.item,
        id: this.item.id,
        code_origin_lis: this.item.code_origin_lis,
        material: this.item.sample.material,
        amount: this.totalSelectedTimes,
        notes: this.item.notes,
        collectTimes: this.listCurveItems,
        urgent: this.item.urgent
      })
    },
    focusNextField(id) {
      document.getElementById(id).focus()
    }
  },
  computed: {
    ...mapGetters(['isExamProfile', 'allowExamUrgent', 'isEditingOrder']),
    totalSelectedTimes: function () {
      return this.listCurveItems.length
    },
    material: {
      get: function () {
        if (!this.item || !this.item.details || !this.item.details.materials || !this.item.sample.material) {
          return null
        }

        // Busca na lista de materiais disponiveis
        // aquele que possui o mesmo id do item da store
        for (let i = 0; i < this.item.details.materials.length; i++) {
          let element = this.item.details.materials[i]
          if (element.id === this.item.sample.material) {
            return element
          }
        }
      },
      set: function (value) {
        if (JSON.stringify(value).length > 2) {
          this.updateExam({
            raw: this.item,
            id: this.item.id,
            code_origin_lis: this.item.code_origin_lis,
            material: !value ? 0 : value.id,
            amount: this.item.sample.amount,
            notes: this.item.notes,
            urgent: this.item.urgent
          })
        }
      }
    },
    notes: {
      get: function () {
        if (!this.item) {
          return ''
        }
        return this.item.notes
      },
      set: function (value) {
        if (!this.item || !this.item.sample) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: this.item.sample.amount,
          notes: value,
          urgent: this.item.urgent
        })
      }
    },
    urgent: {
      get: function () {
        if (!this.item) {
          return ''
        }
        return this.item.urgent
      },
      set: function (value) {
        if (!this.item || !this.item.sample) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          code_origin_lis: this.item.code_origin_lis,
          material: this.item.sample.material,
          amount: this.item.sample.amount,
          notes: this.item.notes,
          urgent: value
        })
      }
    }
  },
  mounted() {
    // if exam profile must have basal(152) as default
    if (this.item.details.isFromProfile) {
      this.listCurveItems = [152]
      this.item.sample.collect_times = [152]
      this.item.editing = false
    }
    this.id = this._uid
    let self = this

    for (let key in this.item.details.collectTimes) {
      if (this.item.details.collectTimes.hasOwnProperty(key)) {
        let collectTime = this.item.details.collectTimes[key]
        if (collectTime.value || collectTime.time === 'Basal') {
          self.listCurveItems.push(collectTime.id)
        }
      }
    }

    this.materialOptions = this.item.details.materials.map(function (item) {
      return { label: item.name, value: item.name }
    })
    this.analyticsSuccessInsertingExam(this.item.details.id)
    Vue.nextTick(function () {
      self.validateOnMount()
    })
  }
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/mixins';
@import '../../../../static/stylesheets/components/orders/common-exam';

.exam-curve__container {
  .exam-curve {
    &__curves {
      display: flex;
      flex-direction: column;
      padding: 0 12px;

      &__items {
        display: flex;
        flex-wrap: wrap;
        border-top: 1px solid #c2c2c2;
        border-bottom: 1px solid #c2c2c2;
        padding: 19px 0;
        margin-bottom: 10px;
        flex-direction: column;
        height: 300px;
      }

      &__item {
        width: 16.66%;
        padding-bottom: 6px;
        display: flex;
        align-items: center;

        &:nth-child(6n) {
          width: 15%;
        }

        label.exam-curve__curves__item__label {
          font-size: 13px;
          text-align: left;
          padding-left: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: -5px;
          margin-bottom: 0;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
